import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useSnackbar } from 'notistack';
import { Dialog, DialogContent, DialogActions, Button, Typography } from '@material-ui/core';
import ChangePasswordModal from './ChangePasswordModal';
import { HIDE_FORCE_CHANGE_PASSWORD_MODAL } from '../actions';
import { setSnackbarRef } from '../../utils';
const ChangePasswordPopUp = ({ open, onClose, responseData }) => {
    const [showChangePasswordForm, setShowChangePasswordForm] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        setSnackbarRef(enqueueSnackbar);
    }, [enqueueSnackbar]);

    useEffect(() => {
        if (open) {
            setShowChangePasswordForm(false);
        }
    }, [open]);

    if (open && !showChangePasswordForm) {
        return (
            <Dialog open={open} maxWidth='xs' PaperProps={{ ref: node => node && node.style.setProperty('min-height', 'min-content', 'important') }}>
                <DialogContent>
                    <Typography>Your password has expired. Please change your password</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowChangePasswordForm(true)} color='primary' variant='contained'>
                        Change Password
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    return (
        <ChangePasswordModal open={open && showChangePasswordForm} onClose={onClose} responseData={responseData} />
    )
}

const mapStateToProps = state => ({
    open: state.shareReducer.forceChangePasswordModal,
    responseData: state.shareReducer.forceChangePasswordModalData,
});

const mapDispatchToProps = (dispatch) => {
    return {
        onClose: () => dispatch({
            type: HIDE_FORCE_CHANGE_PASSWORD_MODAL,
        })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordPopUp);
